import { useState } from 'react'
import type { Preco, Produto } from '../../db/tipos'
import { mensagemDoProduto } from '../../produtos/mensagemDoProduto'
import { opcoesDoCompartilhar } from '../../produtos/botoesDaFicha'
import { compartilharTexto, linkDoWhatsApp } from '../../pedidos/compartilhar'

// Botao Compartilhar da ficha (decisoes dela, 23/09): texto pronto, e o app
// pergunta "com ou sem preco" a cada envio.
export default function JanelaCompartilhar(props: {
  produto: Produto
  tabelaNome: string | null
  precoAtual: Preco | undefined
  aoFechar: () => void
}) {
  const { produto, tabelaNome, precoAtual } = props
  const opcoes = opcoesDoCompartilhar(tabelaNome, precoAtual)
  // Quando a janela do celular nao abre (http://, navegador antigo), guardamos
  // o texto e oferecemos o WhatsApp -- nunca fingir que enviou.
  const [textoSemJanela, setTextoSemJanela] = useState<string | null>(null)

  async function enviar(comPreco: boolean) {
    const texto = mensagemDoProduto(
      produto,
      comPreco && precoAtual
        ? { preco: precoAtual.preco, precoUnidade: precoAtual.preco_unidade ?? null, minima: precoAtual.quantidade_minima }
        : null,
    )
    const r = await compartilharTexto(texto)
    if (r === 'indisponivel') setTextoSemJanela(texto)
    else if (r === 'compartilhado') props.aoFechar()
  }

  return (
    <div role="dialog" aria-label="Compartilhar produto" className="fixed inset-0 z-40 bg-black/40 flex items-end" onClick={props.aoFechar}>
      <div className="w-full bg-white rounded-t-2xl p-4 space-y-3" onClick={(e) => e.stopPropagation()}>
        <p className="font-semibold text-slate-800">Compartilhar com o cliente</p>
        {textoSemJanela === null ? (
          <>
            {opcoes.comPreco && (
              <button type="button" onClick={() => void enviar(true)} className="w-full rounded-lg bg-teal-700 text-white py-3 font-semibold">
                {opcoes.comPreco.rotulo}
              </button>
            )}
            <button type="button" onClick={() => void enviar(false)} className="w-full rounded-lg border border-teal-700 text-teal-700 py-3 font-semibold">
              {opcoes.semPreco.rotulo}
            </button>
            {opcoes.motivo && <p className="text-xs text-slate-500">{opcoes.motivo}</p>}
          </>
        ) : (
          <>
            <p className="text-sm text-slate-600">Este navegador não abriu a janela de compartilhar. Nada foi enviado ainda.</p>
            <a href={linkDoWhatsApp(textoSemJanela)} target="_blank" rel="noopener noreferrer"
              className="block w-full text-center rounded-lg bg-emerald-600 text-white py-3 font-semibold">
              Abrir no WhatsApp
            </a>
          </>
        )}
        <button type="button" onClick={props.aoFechar} className="w-full text-sm text-slate-500 py-2">Fechar</button>
      </div>
    </div>
  )
}
